import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts"

interface ScoreRadarChartProps {
  protocol: "cva" | "sca"
  scores: {
    fragrance_score: number
    aroma_rating?: number
    flavor_score: number
    aftertaste_score: number
    acidity_score: number
    sweetness_score: number
    body_score: number
    overall_score: number
    balance_score?: number
  }
}

export function ScoreRadarChart({ protocol, scores }: ScoreRadarChartProps) {
  const data =
    protocol === "cva"
      ? [
          { attribute: "Fragancia", value: scores.fragrance_score },
          { attribute: "Aroma", value: scores.aroma_rating ?? 0 },
          { attribute: "Sabor", value: scores.flavor_score },
          { attribute: "Retrogusto", value: scores.aftertaste_score },
          { attribute: "Acidez", value: scores.acidity_score },
          { attribute: "Dulzura", value: scores.sweetness_score },
          { attribute: "Cuerpo", value: scores.body_score },
          { attribute: "General", value: scores.overall_score },
        ]
      : [
          { attribute: "Fragancia/Aroma", value: scores.fragrance_score },
          { attribute: "Sabor", value: scores.flavor_score },
          { attribute: "Retrogusto", value: scores.aftertaste_score },
          { attribute: "Acidez", value: scores.acidity_score },
          { attribute: "Cuerpo", value: scores.body_score },
          { attribute: "Balance", value: scores.balance_score ?? 0 },
          { attribute: "General", value: scores.overall_score },
        ]

  const domain: [number, number] = protocol === "cva" ? [0, 9] : [0, 10]

  return (
    <ResponsiveContainer width="100%" height="100%">
      <RadarChart data={data}>
        <PolarGrid stroke="hsl(var(--border))" />
        <PolarAngleAxis
          dataKey="attribute"
          tick={{ fill: "hsl(var(--foreground))", fontSize: 10 }}
        />
        <PolarRadiusAxis
          angle={90}
          domain={domain}
          tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 9 }}
          tickCount={protocol === "cva" ? 5 : 6}
        />
        <Radar
          dataKey="value"
          stroke="hsl(142, 76%, 36%)"
          fill="hsl(142, 76%, 36%)"
          fillOpacity={0.2}
          strokeWidth={2}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: "hsl(var(--card))",
            border: "1px solid hsl(var(--border))",
            borderRadius: "var(--radius)",
          }}
          formatter={(value: number | undefined) => value?.toFixed(1) ?? "0.0"}
        />
      </RadarChart>
    </ResponsiveContainer>
  )
}
